export default __webpack_public_path__ + "static/media/ch.9ab7bfc6.mp3";